import ClientSingleProduct from "../../../Components/Client/ClientSingleProduct";

const SingleProduct = () => {
  return <ClientSingleProduct />;
};

export default SingleProduct;
